/* Verasah — collection & quick-add behaviours (deferred, shared across pages) */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Quick add to cart (featured-collection + collection grid) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();

    // Multi-variant → go to PDP
    if (btn.dataset.singleVariant !== 'true') {
      window.location.href = btn.dataset.productUrl;
      return;
    }

    var variantId = btn.dataset.variantId;
    if (!variantId) { window.location.href = btn.dataset.productUrl; return; }

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('[data-cart-count]');
        if (countEl) { countEl.textContent = cart.item_count; countEl.hidden = false; }
        var subtotalEl = document.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = window.vMoney(cart.total_price);
        var cartItemsEl = document.querySelector('[data-cart-items]');
        if (cartItemsEl) {
          cartItemsEl.innerHTML = cart.item_count === 0
            ? '<p class="cart-drawer__empty">Your cart is empty.</p>'
            : cart.items.map(function (item) {
                var img = item.featured_image && item.featured_image.url
                  ? '<img src="' + item.featured_image.url + '" class="cart-item__image" alt="' + item.title + '" width="80" height="80">'
                  : '';
                var meta = (item.variant_title && item.variant_title !== 'Default Title')
                  ? '<p class="cart-item__meta">' + item.variant_title + '</p>' : '';
                return '<div class="cart-item" data-cart-item="' + item.key + '">' +
                  img + '<div class="cart-item__info">' +
                  '<p class="cart-item__title">' + item.product_title + '</p>' + meta +
                  '<div class="cart-item__qty-row">' +
                  '<button class="qty-btn" data-qty-change="' + item.key + '" data-delta="-1" aria-label="Decrease">−</button>' +
                  '<span class="qty-display">' + item.quantity + '</span>' +
                  '<button class="qty-btn" data-qty-change="' + item.key + '" data-delta="1" aria-label="Increase">+</button>' +
                  '</div>' +
                  '<p class="cart-item__price">' + window.vMoney(item.final_line_price) + '</p>' +
                  '</div></div>';
              }).join('');
        }
        var drawer = document.getElementById('cart-drawer');
        if (drawer) drawer.classList.add('is-open');
        btn.textContent = '✓ Added';
        setTimeout(function () { btn.disabled = false; btn.textContent = originalText; }, 2000);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
        window.location.href = btn.dataset.productUrl;
      });
  });

  /* ── Collection filter panel toggle ── */
  var filterBtn = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.getElementById('collection-filters');
  if (filterBtn && filterPanel) {
    filterBtn.addEventListener('click', function () {
      var open = filterBtn.getAttribute('aria-expanded') === 'true';
      filterBtn.setAttribute('aria-expanded', String(!open));
      filterPanel.hidden = open;
    });
  }

  /* ── Collection sort select ── */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ── Collection filter checkboxes ── */
  document.querySelectorAll('[data-filter-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var url = new URL(window.location.href);
      var checked = Array.from(document.querySelectorAll('[data-filter-input]:checked'));
      url.searchParams.forEach(function (_, key) { if (key.startsWith('filter.')) url.searchParams.delete(key); });
      checked.forEach(function (el) { url.searchParams.append(el.name, el.value); });
      window.location.href = url.toString();
    });
  });

});
